import { type FormEvent, useState } from 'react';
import { Link } from 'react-router';
import { AuthRahmen } from './auth-rahmen.js';
import { PasswortFehler, type PasswortDienst } from './passwort-service.js';

/**
 * Die Bestaetigung klingt fuer bekannte und unbekannte Adressen gleich: Sonst verriete die
 * Seite, welche Adressen ein Konto haben. Das Backend antwortet aus demselben Grund gleich.
 */
export function PasswortVergessenPage({ dienst }: { dienst: PasswortDienst }) {
  const [email, setEmail] = useState('');
  const [meldung, setMeldung] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const [angefordert, setAngefordert] = useState(false);

  async function abschicken(ereignis: FormEvent) {
    ereignis.preventDefault();
    setMeldung(null);
    setLaeuft(true);
    try {
      await dienst.fordereAn(email.trim());
      setAngefordert(true);
    } catch (fehler) {
      setMeldung(
        fehler instanceof PasswortFehler
          ? fehler.text
          : 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.',
      );
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <AuthRahmen>
      <h1>Passwort vergessen</h1>

      {angefordert ? (
        <>
          <div className="eds-alert eds-alert--success" role="status">
            <p>
              Wenn zu dieser Adresse ein Konto besteht, haben wir Ihnen eine E-Mail mit einem Link
              geschickt. Bitte prüfen Sie auch Ihren Spam-Ordner.
            </p>
          </div>
          <Link to="/anmelden" className="eds-button eds-button--secondary">
            Zur Anmeldung
          </Link>
        </>
      ) : (
        <>
          <p className="eds-text-secondary">
            Geben Sie die Adresse Ihres Kontos ein. Sie erhalten dann einen Link, mit dem Sie ein
            neues Passwort festlegen.
          </p>
          {meldung && (
            <div className="eds-alert eds-alert--error" role="alert">
              <p>{meldung}</p>
            </div>
          )}
          <form onSubmit={abschicken}>
            <div className="eds-field">
              <label className="eds-field__label" htmlFor="email">
                E-Mail
              </label>
              <input
                className="eds-field__input"
                id="email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button className="eds-button eds-button--primary" type="submit" disabled={laeuft}>
              {laeuft ? 'Wird gesendet …' : 'Link anfordern'}
            </button>
          </form>
          <Link to="/anmelden">Zurück zur Anmeldung</Link>
        </>
      )}
    </AuthRahmen>
  );
}
